import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";


const LandingPage = ({ user, onShowAuth, onAuthMode, onLogout }) => {
  const [course, setCourse] = useState(null);
  const [books, setBooks] = useState([]);
  const [services, setServices] = useState([]);
  const [news, setNews] = useState([]);
  const [podcast, setPodcast] = useState([]);

const cleanSummary = (s='') =>
  s.replace(/\*\*?T[ÍI]TULO:?\*\*?\s*/gi,'')
   .replace(/\*\*?SINOPSE:?\*\*?\s*/gi,'')
   .trim();
const sourceName = (host='') => {
  const h = (host || '').replace(/^https?:\/\//,'').replace(/^www\./,'').split('/')[0];
  const base = h.split('.')[0] || h;
  return base.charAt(0).toUpperCase() + base.slice(1);
};

    // TODO: A integração com n8n deve enviar via POST para /api/news objetos com:
    // { title, summary, content, created_at }. O front consumirá via fetch como já está.

  useEffect(() => {
    fetchCourse();
    fetchBooks();
    fetchServices();
    fetchNews();
    fetchPodcast();
  }, []);

  const fetchCourse = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/course`);
      const courseData = await response.json();
      setCourse(courseData);
    } catch (error) {
      console.error('Error fetching course:', error);
    }
  };

  const fetchBooks = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/books`);
      const booksData = await response.json();
      setBooks(booksData);
    } catch (error) {
      console.error('Error fetching books:', error);
    }
  };

  const fetchServices = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/services`);
      const servicesData = await response.json();
      setServices(servicesData);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  const fetchNews = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/news`);
      const newsData = await response.json();
      setNews(newsData);
    } catch (error) {
      console.error('Error fetching news:', error);
    }
  };

  const fetchPodcast = async () => {
    try {
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/podcast/rss`);
      const d = await r.json();
      setPodcast(d.items || []);
    } catch (e) {
      setPodcast([]);
    }
  };

  // If user is logged in, redirect to platform
  useEffect(() => {
    if (user && user.role !== 'preview') {
      window.location.href = '/dashboard';
    }
  }, [user]);

  // Book covers mapping
  const getBookCover = (bookId) => {
    const covers = {
      'habeas-cripto': 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=300&h=400&fit=crop',
      'chave-mestra': 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=300&h=400&fit=crop',
      'estrategias-avancadas': 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=300&h=400&fit=crop',
      'rota-cripto': 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=300&h=400&fit=crop',
      'trilhas-invisiveis': 'https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?w=300&h=400&fit=crop',
      'valor-estavel': 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=300&h=400&fit=crop',
      'blockchain-forensics': 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=300&h=400&fit=crop',
      'defi-auto-custodia': 'https://images.unsplash.com/photo-1640340434855-6084b1f4901c?w=300&h=400&fit=crop',
      'evolucao-tributaria': 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=300&h=400&fit=crop',
      'metodo-anonimizacao': 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=300&h=400&fit=crop',
      'no-limite-da-lei': 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=300&h=400&fit=crop',
      'offshore-anonimato': 'https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=300&h=400&fit=crop'
    };
    return covers[bookId] || 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=300&h=400&fit=crop';
  };

  return (
    <div className="landing-page">
      {/* Navigation */}
      <nav className="navbar">
        <div className="navbar-content">
          <div className="logo" data-testid="logo">
            <img src="/logo.png" alt="Habeas Cripto" style={{ height: '40px' }} />
          </div>
          <div className="nav-actions">
            {user ? (
              <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <span style={{ color: 'var(--silver-mist)' }}>Olá, {user.name}</span>
                <button className="btn-ghost" onClick={() => window.location.href = '/dashboard'} data-testid="dashboard-btn">
                  Plataforma
                </button>
                <button className="btn-ghost" onClick={onLogout} data-testid="logout-btn">
                  Sair
                </button>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button 
                  className="btn-ghost" 
                  onClick={() => { onAuthMode('login'); onShowAuth(true); }}
                  data-testid="login-btn"
                >
                  Entrar
                </button>
                <button 
                  className="btn-primary" 
                  onClick={() => { onAuthMode('register'); onShowAuth(true); }}
                  data-testid="register-btn"
                >
                  Cadastrar
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg"></div>
        <div className="hero-content">
          <h1 className="hero-title" data-testid="hero-title">
            Domine o Direito na Blockchain
          </h1>
          <p className="hero-subtitle" data-testid="hero-subtitle">
            O único Curso especializado em direito blockchain, criptomoedas e IA voltado para empresas, advogados e operadores.
            <br />
            Torne-se um especialista em proteção patrimonial e anonimização!
            <br />
            Todas as técnicas e análises sobre como proteger seu patrimônio de golpes, desde auto-custódia, privacidade elevada em transações, estratégias de proteção patrimonial, métodos de anonimização, arquiteturas e blockchain forensics.
          </p>
          <div className="hero-cta">
            {user ? (
              <button 
                className="btn-primary" 
                onClick={() => window.location.href = '/dashboard'}
                data-testid="access-platform-btn"
              >
                Acessar Plataforma
              </button>
            ) : (
              <>
                <button 
                  className="btn-primary" 
                  onClick={() => { onAuthMode('register'); onShowAuth(true); }}
                  data-testid="get-started-btn"
                >
                  Começar Agora
                </button>
                <button 
                  className="btn-secondary" 
                  onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                  data-testid="learn-more-btn"
                >
                  Saber Mais
                </button>
              </>
            )}
          </div>
        </div>
      </section>

      {/* About Section - Updated */}
      <section className="section" id="about">
        <div className="section-title">
          <h2 data-testid="about-title">Quem Somos</h2>
        </div>
        <div className="glass-card" style={{ padding: '3rem', marginBottom: '2rem' }}>
          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', opacity: '0.9', lineHeight: '1.7' }}>
              O <strong>HABEAS CRIPTO</strong> nasceu como um espaço de educação, mentoria e assessoria jurídica voltado ao 
              universo dos criptoativos, da blockchain e da tecnologia aplicada ao direito e aos negócios. Somos uma equipe 
              multidisciplinar formada por advogados, especialistas em compliance, contadores, profissionais de tecnologia e 
              estrategistas de negócios. Essa composição permite enxergar o mercado de forma ampla, aliando segurança jurídica, 
              visão empresarial e inovação tecnológica.
            </p>
            <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', opacity: '0.9', lineHeight: '1.7' }}>
              O projeto é liderado pela advogada empresarial <strong>Gilmara Nagurnhak</strong>, que construiu sua trajetória no 
              direito tributário e empresarial e decidiu expandir sua atuação para o campo dos criptoativos, antecipando os desafios 
              que esse ecossistema traz para pessoas físicas e jurídicas. A partir dessa liderança, atuamos de maneira inovadora, 
              traduzindo a complexidade regulatória, fiscal, tecnológica e de governança em soluções práticas, seguras e acessíveis.
            </p>
            <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', opacity: '0.9', lineHeight: '1.7' }}>
              Nosso propósito é tornar o universo cripto mais compreensível, viável e estrategicamente vantajoso para empresários, 
              advogados e operadores que desejam ampliar sua atuação e para empresas que buscam implementar soluções baseadas em 
              blockchain, tokenização, smart contracts, P2P e Web3. Combinamos conhecimento jurídico, técnico e de mercado para 
              oferecer suporte completo: desde a formação de negócios e estruturas de compliance até o desenvolvimento de estratégias 
              jurídicas e empresariais para operações digitais.
            </p>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="section" id="news">
        <div className="section-title">
          <h2 data-testid="news-title">📰 Notícias Crypto</h2>
          <p>Atualizações diárias sobre o universo das criptomoedas e blockchain</p>
        </div>
        <div className="features-grid">
          {news.length === 0 ? (
            <div className="glass-card" style={{ padding: '3rem', textAlign: 'center', gridColumn: '1 / -1' }}>
              <h3 style={{ color: 'var(--cyber-blue)', marginBottom: '1rem' }}>🤖 Notícias em Breve</h3>
              <p style={{ opacity: 0.8 }}>
                Sistema de notícias automáticas sobre criptomoedas será ativado em breve.
                <br />
                Conteúdo com as últimas tendências do mercado crypto.
              </p>
            </div>
          ) : (
            news.slice(0, 3).map((article, index) => (
              <div key={index} className="glass-card" style={{ padding: '2rem' }}>
                <div style={{ 
                  height: '120px', 
                  background: 'var(--gradient-cyber)', 
                  borderRadius: '8px', 
                  marginBottom: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <span style={{ fontSize: '2rem' }}>📰</span>
                </div>
                <h4 style={{ color: 'var(--neon-green)', marginBottom: '0.5rem' }}>
                  FONTE: {sourceName(article.source)} — {article.title.replace(/^\s*\*{0,2}T[ÍI]TULO:?\*{0,2}\s*/i,'').trim()}
                </h4>

                <p style={{ fontSize: '0.9rem', marginBottom: '0.75rem', opacity: 0.8 }}>
                  SINOPSE: {cleanSummary(article.summary)}
                </p>

                <div style={{ fontSize: '0.8rem', opacity: 0.6, display:'flex', justifyContent:'space-between', gap:'1rem', flexWrap:'wrap' }}>
                  <span>{new Date(article.created_at).toLocaleDateString('pt-BR')}</span>
                  <span>
                    <a
                      href={article.url}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color:'var(--cyber-blue)' }}
                    >
                      Abrir matéria
                    </a>
                  </span>
                </div>
              </div>
            ))
          )}
        </div>
      </section>

            {/* Podcast Section */}
            <section className="section" id="podcast">
              <div className="section-title">
                <h2>🎧 Pod Habeas Cripto</h2>
                <p>Episódios mais recentes</p>
              </div>

              <div className="features-grid">
                {podcast.length === 0 ? (
                  <div className="glass-card" style={{ padding: '2rem', gridColumn: '1 / -1', textAlign: 'center' }}>
                    <p style={{ opacity: 0.8 }}>Carregando episódios...</p>
                  </div>
                ) : (
                  podcast.slice(0,6).map((e) => (
                    <div key={e.id} className="glass-card" style={{ padding: '1.5rem' }}>
                      <div style={{ fontWeight: '600', marginBottom: '0.5rem' }}>{e.title}</div>
                      <div style={{ fontSize: '0.9rem', opacity: 0.8, marginBottom: '0.75rem' }}>{e.description}</div>
                      {e.audio_url && <audio controls src={e.audio_url} className="w-full" />}
                    </div>
                  ))
                )}
              </div>

              <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                <Link to="/podcast" className="btn-secondary" style={{ textDecoration:'none' }}>
                  Ver página do Podcast
                </Link>
              </div>
            </section>

      {/* Services Section - Updated */}
      <section className="section" id="services">
        <div className="section-title">
          <h2 data-testid="services-title">Mentoria e Assessoria Especializada</h2>
        </div>

        <div className="glass-card" style={{ padding: '3rem', marginBottom: '2rem' }} data-testid="service-p2p">
          <h3 style={{ color: 'var(--neon-green)', marginBottom: '1.5rem', fontSize: '2rem' }}>
            Mentoria e Assessoria para Estruturação de Empresas P2P em Criptoativos
          </h3>

          <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: '0.9', lineHeight: '1.7' }}>
            Criar e operar uma empresa P2P no mercado de criptoativos exige muito mais do que apenas tecnologia.
            Esses negócios enfrentam barreiras que vão desde resistência bancária até complexidades regulatórias e contábeis.
            A ausência de padronização clara sobre como bancos devem lidar com operações em cripto gera dificuldades para
            abertura e manutenção de contas. No campo contábil, há desafios em classificar corretamente os ativos digitais
            e reportar movimentações de forma que seja transparente e aceita pelos órgãos fiscais.
          </p>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: '0.9', lineHeight: '1.7' }}>
            Outro ponto sensível é a implementação de processos de KYC (Know Your Customer) e AML (Anti-Money Laundering),
            que demandam tecnologia e compliance alinhados para reduzir riscos e atender exigências regulatórias crescentes.
            Empresas P2P também precisam lidar com incertezas jurídicas, já que as regras variam entre jurisdições e mudam com frequência.
          </p>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: '0.9', lineHeight: '1.7' }}>
            Nossa mentoria e assessoria oferecem um acompanhamento completo: desde a escolha da estrutura societária até a
            modelagem de processos de compliance, integração com parceiros bancários, estratégias de gestão de risco e orientação
            jurídica-tributária específica. O objetivo é transformar o desafio em um diferencial competitivo, permitindo que o
            negócio opere de forma segura, sustentável e alinhada ao mercado e às normas.
          </p>

          <div style={{ marginTop: '2rem' }}>
            <h4 style={{ color: 'var(--cyber-blue)', marginBottom: '1rem' }}>O que inclui nossa assessoria:</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem' }}>
              {[
                'Estruturação jurídica e societária para empresas P2P',
                'Implementação de processos KYC/AML completos',
                'Estratégias de proteção patrimonial avançada',
                'Compliance regulatório e tributário',
                'Blindagem de ativos com criptomoedas',
                'Técnicas de anonimização e privacidade',
                'Análise de riscos e forensics blockchain',
                'Orientação sobre DeFi e auto-custódia'
              ].map((detail, index) => (
                <div key={index} style={{
                  background: 'rgba(0, 255, 136, 0.1)',
                  padding: '1rem',
                  borderRadius: '8px',
                  borderLeft: '4px solid var(--neon-green)'
                }}>
                  <p style={{ margin: 0, fontSize: '0.95rem' }}>✓ {detail}</p>
                </div>
              ))}
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '3rem' }}>
            <a
              href="https://wa.me/5547991158926"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              data-testid="contact-whatsapp-btn"
              style={{ padding: '1rem 2rem', fontSize: '1.1rem', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}
            >
              📱 Solicitar Consultoria
            </a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section" id="features">
        <div className="section-title">
          <h2 data-testid="features-title">Por que escolher o Habeas Cripto?</h2>
        </div>
        <div className="features-grid">
          <div className="glass-card feature-card" data-testid="feature-protection">
            <div className="feature-icon">🛡️</div>
            <h3>Proteção Patrimonial Avançada</h3>
            <p>Estratégias completas de blindagem patrimonial com criptoativos, baseadas nos livros "Chave Mestra" e "Estratégias Avançadas".</p>
          </div>
          <div className="glass-card feature-card" data-testid="feature-privacy">
            <div className="feature-icon">🔒</div>
            <h3>Privacidade Elevada</h3>
            <p>Métodos de "Trilhas Invisíveis" e "Rota Cripto" para anonimização e proteção de transações.</p>
          </div>
          <div className="glass-card feature-card" data-testid="feature-forensics">
            <div className="feature-icon">🔍</div>
            <h3>Blockchain Forensics</h3>
            <p>Domine "Rastros na Cadeia" para identificar e se proteger de golpes usando análise forense avançada.</p>
          </div>
          <div className="glass-card feature-card" data-testid="feature-expert">
            <div className="feature-icon">👩‍⚖️</div>
            <h3>Expertise Reconhecida</h3>
            <p>Aprenda com a Dra. Gilmara Nagurnhak, autora de 13+ livros sobre criptoativos e proteção patrimonial.</p>
          </div>
          <div className="glass-card feature-card" data-testid="feature-defi">
            <div className="feature-icon">⚡</div>
            <h3>DeFi e Auto-custódia</h3>
            <p>Migração de riscos e ampliação da liberdade financeira através de finanças descentralizadas.</p>
          </div>
          <div className="glass-card feature-card" data-testid="feature-compliance">
            <div className="feature-icon">⚖️</div>
            <h3>Compliance Legal</h3>
            <p>Navegação segura entre privacidade e compliance, respeitando os limites da lei.</p>
          </div>
        </div>
      </section>

            {/* Books Section (dinâmico com fallback estático) */}
            <section className="section" id="books">
              <div className="section-title">
                <h2 data-testid="books-title">📚 Biblioteca Especializada</h2>
                <p>Obras de Gilmara Nagurnhak</p>
              </div>

              {books && books.length > 0 ? (
                /* --- DINÂMICO --- */
                <div className="features-grid">
                  {books.map(b => (
                    <div key={b.id} className="glass-card" style={{ padding:'1.5rem' }}>
                      <div style={{
                        height:'260px', borderRadius:'8px', marginBottom:'1rem',
                        background:`center/cover no-repeat url(${b.thumbnail || process.env.REACT_APP_DEFAULT_BOOK_COVER})`
                      }} />
                      <h4 style={{ color:'var(--neon-green)', margin:'0 0 .25rem' }}>{b.title}</h4>
                      {b.subtitle && <div style={{opacity:.8, marginBottom:'.5rem'}}>{b.subtitle}</div>}
                      <p style={{ fontSize:'.95rem', opacity:.9 }}>
                        {(b.description || '').slice(0, 280)}{(b.description||'').length>280?'…':''}
                      </p>
                      <div style={{ fontSize:'.95rem', margin:'0.75rem 0' }}>
                        <strong>Impressa:</strong> R$ {b.price_print} &nbsp;|&nbsp; <strong>Ebook:</strong> R$ {b.price_ebook}
                      </div>
                      <a href={b.url} target="_blank" rel="noreferrer" className="btn-primary" style={{ textDecoration:'none' }}>
                        Comprar da Editora
                      </a>
                    </div>
                  ))}
                </div>
              ) : (
                /* --- ESTÁTICO (seu catálogo) --- */
                (() => {
                  const B = [
                    { id:"habeas", cover:"/habeas.png",
                      title:"Habeas Cripto", subtitle:"O Manual para Advogar com Criptoativos",
                      summary:"Habeas Cripto é o guia essencial para quem deseja atuar, com rigor técnico e visão estratégica...",
                      print:"R$ 242,32", ebook:"R$ 142,36",
                      link:"https://clubedeautores.com.br/livro/habeas-cripto" },
                    { id:"chave", cover:"/chave.png",
                      title:"Chave Mestra", subtitle:"A Arte de Blindar o Patrimônio com Criptoativos",
                      summary:"Para empresários, investidores experientes e agentes estratégicos que buscam blindagem...",
                      print:"R$ 180,26", ebook:"R$ 177,98",
                      link:"https://clubedeautores.com.br/livro/chave-mestra" },
                    { id:"estrategia", cover:"/estrategia.png",
                      title:"ESTRATÉGIAS AVANÇADAS DE PROTEÇÃO PATRIMONIAL EM CRIPTOATIVOS",
                      subtitle:"Construindo liberdade patrimonial com inteligência e segurança",
                      summary:"Manual essencial para investidores, advogados e empresários que desejam proteger...",
                      print:"R$ 138,53", ebook:"R$ 118,61",
                      link:"https://clubedeautores.com.br/livro/estrategias-avancadas-de-protecao-patrimonial-em-criptoativos" },
                    { id:"rota", cover:"/rota.png",
                      title:"Rota Cripto: Privacidade Elevada para Empresários e Investidores Estratégicos",
                      subtitle:"Como operar ativos digitais com proteção máxima sem sair da legalidade",
                      summary:"Guia técnico e juridicamente seguro para operar moedas de privacidade...",
                      print:"R$ 147,84", ebook:"R$ 101,99",
                      link:"https://clubedeautores.com.br/livro/rota-cripto-privacidade-elevada-para-empresarios-e-investidores-estrategicos" },
                    { id:"trilha", cover:"/trilha.png",
                      title:"Trilhas Invisíveis",
                      subtitle:"Como Aumentar a Privacidade em Transações com Criptoativos",
                      summary:"Práticas avançadas de anonimização (CoinJoin, mixers, Wasabi, Whirlpool)...",
                      print:"R$ 142,30", ebook:"R$ 101,99",
                      link:"https://clubedeautores.com.br/livro/trilhas-invisiveis-como-aumentar-a-privacidade-em-transacoes-com-criptoativos" },
                    { id:"valor", cover:"/valor-estavel.png",
                      title:"Valor Estável",
                      subtitle:"Como Utilizar Stablecoins para Preservação e Segurança Patrimonial",
                      summary:"Estratégias práticas para preservar patrimônio com stablecoins...",
                      print:"R$ 136,49", ebook:"R$ 118,61",
                      link:"https://clubedeautores.com.br/livro/valor-estavel" },
                    { id:"revolucao", cover:"/revolucao.jpg",
                      title:"(R)Evolução Tributária na Era Blockchain",
                      subtitle:"Regulação, Riscos, Crimes e Tendências Globais…",
                      summary:"Interseção entre blockchain e Direito Tributário: tributação, smart contracts, DeFi, Drex...",
                      print:"R$ 171,15", ebook:"R$ 112,91",
                      link:"https://clubedeautores.com.br/livro/r-evolucao-tributaria-na-era-blockchain" },
                    { id:"anonima", cover:"/anonima.png",
                      title:"O Método de Anonimização de Criptoativos: Fragmentar e Rotacionar",
                      subtitle:"Proteja-se de golpistas",
                      summary:"Técnicas de rotação de endereços e fragmentação de valores em BTC/ETH/XMR...",
                      print:"R$ 147,04", ebook:"R$ 100,80",
                      link:"https://clubedeautores.com.br/livro/o-metodo-de-anonimizacao-de-criptoativos-fragmentar-e-rotacionar" },
                    { id:"rastro", cover:"/rastro.png",
                      title:"Rastros na Cadeia",
                      subtitle:"Ferramentas de Blockchain Forensics e Análise de Ativos Digitais",
                      summary:"Comparativo de ferramentas (Chainalysis, Elliptic, TRM, etc.)...",
                      print:"R$ 165,93", ebook:"R$ 118,61",
                      link:"https://clubedeautores.com.br/livro/rastros-na-cadeia-ferramentas-de-blockchain-forensics-e-analise-de-ativos-digitais" },
                    { id:"limite", cover:"/limite.png",
                      title:"No limite da lei",
                      subtitle:"Riscos, compliance e evasão em transações privadas com cripto",
                      summary:"Deveres formais (IN 1.888/2019), fronteiras P2P/auto-custódia e modelos práticos...",
                      print:"R$ 142,79", ebook:"R$ 101,99",
                      link:"https://clubedeautores.com.br/livro/no-limite-da-lei-2" },
                    { id:"defi", cover:"/defi.png",
                      title:"DeFi e Auto custódia",
                      subtitle:"Migrando Riscos e Ampliando sua Liberdade Financeira",
                      summary:"Fundamentos de DeFi, hardware wallets, diluição de riscos e autonomia patrimonial...",
                      print:"R$ 141,28", ebook:"R$ 118,61",
                      link:"https://clubedeautores.com.br/livro/defi-e-auto-custodia" },
                    { id:"offshore", cover:"/offshore.jpg",
                      title:"Offshore, Criptomoedas e Anonimato: Arquitetura Secreta",
                      subtitle:"Construindo liberdade patrimonial com inteligência e segurança",
                      summary:"Estruturas offshore + moedas de privacidade + governança internacional...",
                      print:"R$ 159,02", ebook:"R$ 82,99",
                      link:"https://clubedeautores.com.br/livro/offshore-criptomoedas-e-anonimato-arquitetura-secreta" },
                    { id:"fausto", cover:"/fausto.jpg",
                      title:"Fausto e Mefistófeles: O Pacto, a Norma e o Contrato",
                      subtitle:"",
                      summary:"Narrativa + análise de Direito Contratual/Societário na prática empresarial.",
                      print:"R$ 175,54", ebook:"R$ 142,36",
                      link:"https://clubedeautores.com.br/livro/fausto-e-mefistofeles-o-pacto-a-norma-e-o-contrato" }
                  ];
                  return (
                    <div className="features-grid">
                      {B.map(b => (
                        <div key={b.id} className="glass-card" style={{ padding:'1.5rem' }}>
                          <div style={{height:'260px', borderRadius:'8px', marginBottom:'1rem',
                            background:`center/cover no-repeat url(${b.cover})`}} />
                          <h4 style={{ color:'var(--neon-green)', margin:'0 0 .25rem' }}>{b.title}</h4>
                          {b.subtitle && <div style={{opacity:.8, marginBottom:'.5rem'}}>{b.subtitle}</div>}
                          <p style={{ fontSize:'.95rem', opacity:.9 }}>{b.summary}</p>
                          <div style={{ fontSize:'.95rem', margin:'0.75rem 0' }}>
                            <strong>Impressa:</strong> {b.print} &nbsp;|&nbsp; <strong>Ebook:</strong> {b.ebook}
                          </div>
                          <a href={b.link} target="_blank" rel="noreferrer" className="btn-primary" style={{ textDecoration:'none' }}>
                            Comprar da Editora
                          </a>
                        </div>
                      ))}
                    </div>
                  );
                })()
              )}
            </section>

      {/* Course Info Section - Updated */}
      <section className="section" id="course-info">
        <div className="section-title">
          <h2 data-testid="course-title">Conteúdo do Curso</h2>
          <p>Baseado nos livros especializados da Dra. Gilmara Nagurnhak</p>
        </div>
        {course && (
          <div className="course-content">
            <div className="glass-card" style={{ padding: '3rem', marginBottom: '2rem' }}>
              <h3 style={{ color: 'var(--cyber-blue)', marginBottom: '1rem' }} data-testid="course-name">
                {course.title}
              </h3>
              <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: '0.9' }} data-testid="course-description">
                {course.description}
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--cyber-orange)', marginBottom: '1rem' }}>
                    Em Breve
                  </div>
                  <PreRegistrationModal />
                </div>
              </div>
            </div>
            
            <div className="modules-grid" style={{ display: 'grid', gap: '1.5rem' }}>
              {course.modules.slice(0, 10).map((module, index) => (
                <div key={module.id} className="glass-card" style={{ padding: '2rem' }} data-testid={`module-${module.id}`}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                    <div style={{ flex: 1 }}>
                      <h4 style={{ color: 'var(--neon-green)', margin: 0, marginBottom: '0.5rem' }}>
                        Módulo {module.order}: {module.title}
                      </h4>
                      <p style={{ fontSize: '0.85rem', color: 'var(--cyber-blue)', margin: 0, marginBottom: '1rem', opacity: 0.8 }}>
                        Baseado no livro: {module.based_on_book}
                      </p>
                    </div>
                    <span style={{ 
                      background: 'rgba(255, 107, 53, 0.2)',
                      color: 'var(--cyber-orange)',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '20px',
                      fontSize: '0.875rem',
                      whiteSpace: 'nowrap'
                    }}>
                      🚀 Em Breve
                    </span>
                  </div>
                  <p style={{ marginBottom: '1rem', opacity: '0.8' }}>{module.description}</p>
                  
                  {/* Show chapters if available */}
                  {module.chapters && module.chapters.length > 0 && (
                    <div style={{ marginTop: '1rem' }}>
                      <h5 style={{ color: 'var(--cyber-blue)', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                        Conteúdo Programático:
                      </h5>
                      <ul style={{ fontSize: '0.85rem', opacity: 0.8, paddingLeft: '1.2rem' }}>
                        {module.chapters.map((chapter, idx) => (
                          <li key={idx} style={{ marginBottom: '0.25rem' }}>{chapter}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  
                  <div style={{ color: 'var(--cyber-blue)', fontSize: '0.9rem', marginTop: '1rem' }}>
                    ⏱️ {module.duration_minutes} minutos
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>

      {/* CTA Section - Centered */}
      <section className="section" style={{ 
        textAlign: 'center', 
        background: 'var(--gradient-primary)', 
        margin: '4rem auto', 
        borderRadius: '20px',
        maxWidth: '800px',
        padding: '3rem 2rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <h2 style={{ color: 'white', marginBottom: '1.5rem', textAlign: 'center' }} data-testid="cta-title">
          Pronto para proteger seu patrimônio?
        </h2>
        <p style={{ fontSize: '1.2rem', marginBottom: '2rem', opacity: '0.9', color: 'white', textAlign: 'center', maxWidth: '600px' }} data-testid="cta-description">
          Junte-se aos especialistas em proteção patrimonial digital no Brasil
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          {!user && (
            <button 
              className="btn-secondary" 
              style={{ 
                background: 'white', 
                color: 'var(--electric-purple)', 
                border: 'none',
                padding: '1rem 2rem',
                fontSize: '1.1rem',
                fontWeight: 'bold'
              }}
              onClick={() => { onAuthMode('register'); onShowAuth(true); }}
              data-testid="final-cta-btn"
            >
              Proteger Meu Patrimônio
            </button>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer
        style={{
          background: 'var(--deep-space)',
          padding: '3rem 2rem 2rem',
          textAlign: 'center',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <div className="logo">
          <img src="/logo.png" alt="Habeas Cripto" style={{ height: '40px' }} />
        </div>
        <p style={{ opacity: '0.7', marginBottom: '1rem' }}>
          Porque seu patrimônio é a prioridade
        </p>
        <p style={{ fontSize: '0.9rem', opacity: '0.5' }}>
          © 2025 Habeas Cripto. Todos os direitos reservados.
        </p>
      </footer>
    </div>
  );
};

// Pre-registration Modal Component with FIXED Z-INDEX
const PreRegistrationModal = () => {
  const handlePreRegistration = () => {
    // Navega para a página de pré-matrícula
    window.location.href = '/pre-registration';
  };

  return (
    <button 
      className="btn-primary" 
      onClick={handlePreRegistration}
      data-testid="pre-registration-btn"
      style={{ 
        padding: '1rem 2rem', 
        fontSize: '1.1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        cursor: 'pointer'
      }}
    >
      📝 Pré-matrícula
    </button>
  );
};

export default LandingPage;